<script setup lang="ts">
  import type { HTMLAttributes } from 'vue'
  import { cn } from '../cn'

  const props = defineProps<{
    class?: HTMLAttributes['class']
  }>()
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    :class="cn('lucide lucide-trash-icon lucide-trash size-4', props.class)"
  >
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
    <path d="M3 6h18" />
    <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
  </svg>
</template>
